import { queryOptions } from '@tanstack/react-query';
import fileInformationDataGenerator from '@/modules/FileDetail/data/fileInformation/fileInformationDataGenerator.ts';
import { fileInformationQueryFunction } from '@/modules/FileDetail/queries/fileInformation/fileInformationQueryFunction.ts';

export const fileInformationQueryOptions = (id: string) => {
  return queryOptions({
    queryKey: ['file_information', id],
    queryFn: () => fileInformationQueryFunction(id),
    enabled: !!id,
    select(data) {
      return {
        ...data,
        detailCardItems: fileInformationDataGenerator(data),
      };
    },
  });
};
